export function parseMoldMaintenanceDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const toolId = (params.get('toolId') || '').trim();
  const maintenanceIdRaw = params.get('maintenanceId');
  const moldInfoIdRaw = params.get('moldInfoId');
  const maintenanceId = maintenanceIdRaw ? Number(maintenanceIdRaw) : null;
  const moldInfoId = moldInfoIdRaw ? Number(moldInfoIdRaw) : null;

  if (!toolId && !(Number.isFinite(moldInfoId) && moldInfoId > 0)) {
    return null;
  }

  return {
    toolId,
    maintenanceId: Number.isFinite(maintenanceId) && maintenanceId > 0 ? maintenanceId : null,
    moldInfoId: Number.isFinite(moldInfoId) && moldInfoId > 0 ? moldInfoId : null,
  };
}

export function normalizeMoldReceiving(mold) {
  if (!mold || typeof mold !== 'object') {
    return null;
  }

  return {
    ...mold,
    toolID: mold.toolID ?? mold.ToolID ?? '',
    moldInfoID: mold.moldInfoID ?? mold.MoldInfoID ?? mold.id ?? null,
    moldNumber: mold.moldNumber ?? mold.MoldNumber,
    moldDescription: mold.moldDescription ?? mold.MoldDescription,
    customerName: mold.customerName ?? mold.CustomerName,
  };
}
